<template>
	<div class="proposal-table px-3">
			<b-table-simple responsive bordered class="table-sm">
					<b-thead>
							<b-tr>
									<!-- <b-th class="align-middle text-center" v-if="is_editable"></b-th> -->
									<b-th class="align-middle text-center">No.</b-th>
									<b-th class="align-middle text-center" style="min-width: 150px;">KYC Questions</b-th>
									<b-th class="align-middle text-center" style="min-width: 130px;">Answer</b-th>
									<b-th class="align-middle text-center" style="min-width: 100px;">Advisor</b-th>
									<b-th class="align-middle text-center" style="min-width: 200px;">Remark</b-th>
							</b-tr>
					</b-thead>
					<b-tbody>
							<b-tr v-for="(item, index) in tableData" :key="index">
									<!-- <b-td class="align-middle" v-if="is_editable">
										<el-button type="danger" size="mini" @click="deleteHandler(index)" icon="fa fa-times" circle></el-button>
									</b-td> -->
									<b-td class="align-middle text-center">{{ index + 1 }}</b-td>
									<b-td class="align-middle input-cell">
										{{ item.pkyq_question }}
									</b-td>
									<b-td class="align-middle input-cell">
										<el-radio v-model="item.pkyq_answer" :label="0" :disabled="!is_editable">No</el-radio>
										<el-radio v-model="item.pkyq_answer" :label="1" :disabled="!is_editable">Yes</el-radio>
									</b-td>
									<b-td class="align-middle input-cell text-center">
											<!-- <b-form-input type="text" v-model="item.pkyq_description" size="mini"></b-form-input> -->
											<b-avatar v-b-tooltip.hover="proposal.customer_detail.ssa_name" size="32px" :text="_gHlp.formatInitials(proposal.customer_detail.ssa_name)"
												v-if="!_gHlp.isEmpty(proposal.customer_detail.ssa_name)"></b-avatar>
									</b-td>
									<b-td class="align-middle input-cell">
											<b-form-input type="text" v-model="item.pkyq_remark" size="mini" :disabled="!is_editable"></b-form-input>
									</b-td>
							</b-tr>
					</b-tbody>
			</b-table-simple>

			<div class="d-flex justify-content-end" v-if="is_editable">
				<!-- <el-button size="mini" type="info" icon="fa fa-plus" @click="addFeesCharge"> Add Fees & Charges</el-button> -->
				<el-button size="mini" type="primary" icon="fa fa-save" @click="update" :loading="is_loading"> Update</el-button>
			</div>
	</div>
</template>
<script>
import { Select, Radio, Option, Button } from 'element-ui'
import {PROPOSED_REPAYMENT_VIAS} from '@/assets/js/status.js'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import { isEqual, cloneDeep } from 'lodash'
import { mapActions, mapState } from 'pinia'
import { useInvinityStore } from '@/stores/invinityStore'
import { useInitialProposalStore } from '@/stores/initialProposalStore'

export default {
	props: ['psal_id','is_editable', 'proposal'],
	components: {
			[Select.name]: Select,
			[Radio.name]: Radio,
			[Option.name]: Option,
			[Button.name]: Button,
	},
	data() {
			return {
					PROPOSED_REPAYMENT_VIAS:PROPOSED_REPAYMENT_VIAS,
					tableData: [],
					typeOptions: [],
					originalTableData: [],
					is_updated: false,
					is_loading: false,
			}
	},
	created(){
		this.initComponent()
	},
	watch: {
		psal_id: {
			handler(newVal) {
				if(!_gHlp.isEmpty(newVal)){
					this.getListing(newVal)
				}
			},
			immediate: true,
		}
	},
	methods: {
			...mapActions(useInitialProposalStore, ['getKycQuestionList','bulkUpSertKycQuestions']),
			initComponent(){
				
			},
			getListing(psal_id){
				this.tableData = []
				this.originalTableData = []
				let params = {
					search:{
						pkyq_psal_id: psal_id,
					},
					paginate:'no_paginate'
				}
				this.getKycQuestionList(params).then(resp => {
					let tableData = _gHlp.getValue(resp,'data',[]);
					tableData.forEach(item => {
						item.pkyq_advisor_id = this.proposal.customer_detail.ssa_id
						item.pkyq_psal_id = this.psal_id
						this.tableData.push(item)
					})
					this.originalTableData = cloneDeep(this.tableData);
				}).catch(e => {
					_gNotif.errorFunction(e)
				})
			},
			async update(){
				this.is_loading = true
				if(await this.bulkUpSertKycQuestions(this.psal_id, this.tableData, this.originalTableData)){
					_gNotif.notifySuccess('<b>KYC QUestions</b> - Successfully Updated.')
					initialProposalEventBus.$emit('refresh-proposal-detail')
				}
				this.is_loading = false
			}
	}
}
</script>